/* eslint-disable no-useless-catch */
import { API } from "../api";
import {
  AMAZON_GENERATE_REPORT_URL,
  AMAZON_RATES_URL,
  AMAZON_CHARGES_URL,
  AMAZON_WEIGHT_CHARGES_URL,
} from "../constants/url.constant";

export const GET_RATES = "GET_RATES";
export const GET_CHARGES = "GET_CHARGES";
export const GET_WEIGHT_CHARGES = "GET_WEIGHT_CHARGES";

export const getCharges = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(AMAZON_CHARGES_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_CHARGES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getRates = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(AMAZON_RATES_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_RATES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getWeightCharges = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(AMAZON_WEIGHT_CHARGES_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_WEIGHT_CHARGES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const generateReport = (data) => {
  return async () => {
    try {
      return await API.post(AMAZON_GENERATE_REPORT_URL, data);
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = {
    chargeColumns: [],
    chargeTableRows: [],
    chargeTotalRows: 0,
    amazonTableRows: [],
    totalRows: 0,
  },
  { type, payload }
) {
  switch (type) {
    case GET_CHARGES:
      return {
        ...state,
        chargeColumns: payload.columns,
        chargeTableRows: payload.rows,
        totalRows: payload.count
      };
    case GET_WEIGHT_CHARGES:
      return {
        ...state,
        amazonTableColumns: payload.columns,
        amazonTableRows: payload.rows,
        totalRows: payload.count
      };
    default:
      return state;
  }
}
